import {useContext} from 'react'

import Context from '@s-ui/react-context'
import IconArrowRightDefault from '@adv-mt/mt-svg-icons/lib/ArrowRightDefault.js'
import {Button, BUTTON_INTENTS, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body1} from '@adv-mt/ui/typography'

import {BASE_CLASS} from './FormFields.js'

const PublishAdCrossSell = () => {
  const {i18n, domain} = useContext(Context)
  const appName = domain.get('config').get('APP_NAME')

  return (
    <div className={`${BASE_CLASS}-crossSell`}>
      <Body1 className={`${BASE_CLASS}-crossSellTitle`} highlight>
        {i18n.t(`CONTACT_SELLER.CONFIRMATION.PTA_${appName}`)}
      </Body1>
      <Button
        href={i18n.t(`HOME_SERVICES_TRADING_${appName}_SELL_URL`)}
        variant={BUTTON_VARIANTS.OUTLINE}
        intent={BUTTON_INTENTS.PRIMARY}
        size={BUTTON_SIZES.MEDIUM}
        shape={BUTTON_SHAPES.CIRCLE}
      >
        {i18n.t('PTA_SUBMIT')}
        <Icon className={`${BASE_CLASS}-crossSellCtaIcon`} size={ICON_SIZES.MD}>
          <IconArrowRightDefault size={ICON_SIZES.MD} />
        </Icon>
      </Button>
    </div>
  )
}

PublishAdCrossSell.displayName = 'ContactFormV2PublishAdCrossSell'

export default PublishAdCrossSell
